import { motion } from "framer-motion"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import type { FlashcardActivity } from "@/services/api/odin/activities/flashcards/study-session/update"
import FlashcardEditModal from "../edit-modal"
import { useAuth } from "@/modules/auth/store"
import { UserRole } from "@/shared/entities/users"

interface FlashcardDeckProps {
  showAnswer: boolean
  activity: FlashcardActivity
  handleOnEditFlashcard: (question: string, answer: string) => void
}

export default function FlashcardDeck({
  activity,
  showAnswer,
  handleOnEditFlashcard,
}: FlashcardDeckProps) {
  const { user } = useAuth()
  const isSupervisor = user?.role === UserRole.SUPERVISOR

  return (
    <div className="flex min-h-[400px] w-full items-center justify-center p-4 sm:p-6 md:p-8 lg:p-12">
      <div
        className="relative h-full w-full max-w-2xl cursor-pointer shadow-lg"
        style={{ perspective: "1000px" }}
      >
        <motion.div
          className="relative h-full w-full"
          animate={{ rotateY: showAnswer ? 180 : 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          style={{ transformStyle: "preserve-3d" }}
        >
          <Card className="absolute h-full w-full">
            <CardContent className="flex h-full items-center justify-center p-4 sm:p-6">
              <p className="break-words text-center text-base font-bold sm:text-lg md:text-xl">
                {activity.next.question}
              </p>
            </CardContent>
          </Card>
          <Card
            className="absolute h-full w-full items-center bg-primary-50 p-4"
            style={{
              transform: "rotateY(180deg)",
              backfaceVisibility: "hidden",
            }}
          >
            {showAnswer && isSupervisor && (
              <CardHeader className="p-0">
                <FlashcardEditModal
                  flashcard={activity}
                  handleOnEditFlashcard={handleOnEditFlashcard}
                />
              </CardHeader>
            )}
            <CardContent className="flex h-full flex-col items-center justify-center gap-12 text-center">
              <p className="font-regular text-md">{activity.next.question}</p>
              <span className="text-xl font-semibold">{activity.next.answer}</span>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  )
}
